import { z } from 'zod';

export const fileUploadStatusSchema = z.object({
  id: z.number(),
  originalFileName: z.string(),
  status: z.enum(['IN_PROGRESS', 'COMPLETED']),
  totalChunks: z.number().nullable(),
  receivedChunks: z.array(z.number()),
});
